export default __webpack_public_path__ + "static/media/3-4.c36cf77b.webp";